export * from 'server/models/BatchesDashboard';


// WEBPACK FOOTER //
// ./data/models/BatchesDashboard.ts